<template>
  <div class="wrapper">
    <div class="k-modal-title mb-2">Выберите тип подписки:</div>
    <div
      v-for="(type, index) in subscribe_types"
      :key="index" 
      class="k-modal-sticker subscribe-sticker mb-1" 
      :class="{ selected: currentData === type.count }"
      @click="currentData = type.count"
    >
      <div class="d-flex flex-column">
        <span class="k-modal-sticker__title" v-html="type.title"></span>
        <span class="k-modal-sticker__subtitle" v-html="type.subtitle"></span>
      </div>
      <div class="subscribe-sticker__sale" v-if="type.sale">
        -{{ type.sale }}%
      </div>
    </div>
    <div v-if="!appliedPromo">
      <div class="k-modal-title mb-2">Укажите промокод:</div>
      <div class="k-modal-sticker subscribe-pormocode">
        <input type="text" v-model="currentPromo">
      </div>
      <p v-if="promoError">Такого промокода не существует</p>
      <div class="k-modal-button green mt-2 mb-4" @click="checkPromocode" :disabled="!currentPromo">
        Применить
      </div>
    </div>
    <div v-else class="text-center">
      Промокод успешно применен
    </div>

    <div class="k-modal-button mt-4 mb-2" :class="{ disabled: !currentData }" @click="$emit('pay')">
      Оплатить
    </div>
    <div class="k-modal-button" style="background: #f68c1e" v-if="$mq === 'sm' || $mq === 'xs'" @click="$emit('back')">
      Назад
    </div>

    <div class="loading-indication" v-if="busyState">
      <k-spinner />
    </div>
  </div>
</template>

<script>
import PriceHelper from '../../utils/price-helper';
import { mapGetters, mapActions } from 'vuex';
import { buyRegularMenu, addUserToMenu } from '../../api/SubscribeApi';
import KSpinner from '../../components/TheSpinner';

export default {
  components: { KSpinner },
  props: {
    data: {
      type: [String, Number],
      default: '',
    },
    steps: {
      type: Array,
      default: () => [],
    },
    menuId: String,
  },
  mounted() {
    const types = this.steps.find(el => el.step === 1).data;
    const days = this.steps.find(el => el.step === 2).data === 'five_days' ? 5 : 7;
    
    this.prices = new PriceHelper(types, days);
    this.subscribe_types = this.prices.getPrices().map((el, index) => {
      el = {...el},
      el.type = `${index} + 1`;
      return el;
    });
  },
  data: () => ({
    subscribe_types: [
      { type: '1', title: '500 ₽ за месяц', subtitle: 'пн-вс', sale: null, },
      { type: '2', title: '1200 ₽ за 3 месяца', subtitle: '400 ₽ за один меяц', sale: 10 },
      { type: '3', title: '2100 ₽ за 6 месяцев', subtitle: '350 ₽ за один меяц', sale: 30 },
      { type: '4', title: '3000 ₽ за год', subtitle: '250 ₽ за один меяц', sale: 50 },
    ],
    promoError: false,
    appliedPromo: false,
    prices: null,
    currentPromo: '',
    busyState: false,
  }),
  computed: {
    ...mapGetters([
      'getUserSubscribes',
      'getUserFamily',
    ]),
    currentData: {
      get() { return this.data },
      set(value) { this.$emit('update', value) }
    },
    getMainProfile() {
      return this.getUserFamily.find(el => el.is_main === 't');
    },
  },
  methods: {
    ...mapActions([
      'loadUser',
    ]),
    async checkPromocode() {
      if (this.busyState) return;

      this.busyState = true;

      const current = this.getUserSubscribes.find(el => el.menu_id === this.menuId);
      this.promoError = false;
      this.appliedPromo = false;

      try {
        if (current && current.is_paid === 'f') {
          const { data } = await buyRegularMenu({
            menu_id: this.menuId,
            meal_types: this.steps[0].data,
            periodicity:  this.steps[1].data,
            months_count: this.steps[2].data,
            promocode: this.currentPromo.toUpperCase().trim(),
          }, true, current.id)

          if (!data.success) throw Error();
        } else {
          const { data } = await buyRegularMenu({
            menu_id: this.menuId,
            meal_types: this.steps[0].data,
            periodicity:  this.steps[1].data,
            months_count: this.steps[2].data,
            promocode: this.currentPromo.toUpperCase().trim(),
          })

          await addUserToMenu({
            profile_id: this.getMainProfile.id,
            subscription_id: data.data.subscription.id,
            meal_types: this.steps[0].data,
          });

          await this.loadUser();

          if (!data.success) throw Error();
        }

        if (this.currentPromo) {
          this.applyPromocode();
        }
      } catch(err) {
        console.log('err', err)
        this.promoError = true;
      }
      
      this.busyState = false;
    },
    applyPromocode() {
      this.prices.applyPromo(this.currentPromo);
      this.appliedPromo = true;
      this.subscribe_types = this.prices.getPrices().map((el, index) => {
        el = {...el},
        el.type = `${index} + 1`;
        return el;
      });
      this.$emit('promo', this.currentPromo);
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
}
.subscribe-sticker {
  position: relative;
  overflow: hidden;
}
.subscribe-sticker__sale {
  height: 25px;
  width: 125px;
  background: #9dc43b;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 0;
  transform: rotate(30deg) translate(37px, -20px);
}

.subscribe-pormocode {
  border: 1px solid #F68C1E;
  box-sizing: border-box;
  border-radius: 8px;

  input {
    width: 100%;
    border: unset;
    outline: none;
    padding: 0 20%;
    text-align: center;
    font-size: 20px;
    color: #616161;
  }
}

</style>